type AppIfProps = {
  condition: boolean;
  children: React.ReactNode;
  elseRender?: React.ReactNode;
};

const AppIf = ({ condition, children, elseRender }: AppIfProps) => {
  return <>{condition ? children : elseRender || null}</>;
};

export default AppIf;
